<template>
  <div class="app-main__inner">
    <TituloComponent
      icono-titulo="fas fa-pencil-alt"
      texto-titulo="Editar Plan Medico"
    ></TituloComponent>
    <div class="main-card mb-3 card col-12 col-md-8 offset-md-2">
      <div class="card-body">
        <form @submit.prevent="guardarPlanMedico()">
          <float-label label="Código:" clase>
            <input
              v-model="planMedico.codigo"
              id="codigo"
              placeholder="Ingresar un código..."
              type="text"
              class="form-control"
              :class="
                enviado && !$v.planMedico.codigo.required ? 'is-invalid' : ''
              "
            />
            <template v-slot:validation>
              <div
                class="invalid-feedback"
                v-if="enviado && !$v.planMedico.codigo.required"
              >
                Debe ingresar un código
              </div>
            </template>
          </float-label>
          <float-label label="Descripción:" clase>
            <input
              v-model="planMedico.descripcion"
              id="descripcion"
              placeholder="Ingresar una descripción..."
              type="text"
              class="form-control"
              :class="
                enviado && !$v.planMedico.descripcion.required
                  ? 'is-invalid'
                  : ''
              "
            />
            <template v-slot:validation>
              <div
                class="invalid-feedback"
                v-if="enviado && !$v.planMedico.descripcion.required"
              >
                Debe ingresar una descripción
              </div>
            </template>
          </float-label>
          <button class="mt-1 btn btn-info float-right">Guardar</button>
        </form>
      </div>
    </div>
  </div>
</template>
<script>
import TituloComponent from "@/components/layouts/TituloComponente";
import FloatLabel from "@/components/layouts/FloatLabel";
import { required } from "vuelidate/lib/validators";
import axios from "axios";
import Swal from "sweetalert2";
import PlanMedico from "@/models/planMedico";
export default {
  name: "EditarPlanMedico",
  components: {
    TituloComponent,
    FloatLabel,
  },
  data() {
    return {
      planMedico: new PlanMedico(null, "", ""),
      loading: false,
      enviado: false,
    };
  },
  validations: {
    planMedico: {
      codigo: { required },
      descripcion: { required },
    },
  },
  mounted() {
    this.planMedico.id = this.$route.params.id;
    this.getPlanMedico();
  },
  methods: {
    getPlanMedico() {
      this.loading = true;
      axios
        .get("planmedico/" + this.planMedico.id)
        .then((res) => {
          console.log(res.data);
          if (res.data.success) {
            this.planMedico = res.data.planmedico;
          }
        })
        .catch(() => {
          Swal.fire({
            icon: "warning",
            title: "Oopss..",
            text: `No se ha encontrado Planes medicos.`,
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    guardarPlanMedico() {
      this.enviado = true;
      this.loading = true;
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.loading = false;
        return false;
      }
      axios
        .put("/planmedico/" + this.planMedico.id, this.planMedico)
        .then((res) => {
          if (res.data.success) {
            Swal.fire({
              icon: "success",
              title: "Éxito",
              text: `${res.data.planmedico.descripcion} se editó con éxito.`,
            });
            this.$router.push({ name: "ListarPlanMedico" });
          }
        })
        .catch((error) => {
          console.log(error);
          Swal.fire({
            icon: "error",
            title: "Oopss..",
            text: `No se ha podido completar la operación.`,
          });
        })
        .finally(() => (this.loading = false));
    },
  },
};
</script>